// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { MultiTimezoneTooltip } from '@/components/multi-timezone-tooltip';
import { DateTime } from 'luxon';
import { ReactNode } from 'react';

const PHASE_DATE_FORMAT = 'MMM d, yyyy';

/**
 * Renders a phase date as stepper subtext: a simply formatted date that
 * resolves to the full multi-timezone datetime on hover, matching the
 * shipment phase indicator. Returns undefined when no date is set so the
 * phase renders without a subtext.
 */
export function phaseDateSubtext(date: DateTime | null | undefined): ReactNode {
  if (!date) return undefined;
  return (
    <MultiTimezoneTooltip timestamp={date} placement="bottom">
      {date.toFormat(PHASE_DATE_FORMAT)}
    </MultiTimezoneTooltip>
  );
}
